import { useLocation } from 'react-router-dom';
import { usePageCrumbs, type Crumb } from './BreadcrumbContext';
import { reportCrumb, routeCrumb } from './routeCrumbs';

/** The whole trail: the route's sidebar page, a report's name, then the page's own crumbs. */
export const useTrail = (): Crumb[] => {
  const { pathname } = useLocation();
  const pageCrumbs = usePageCrumbs();
  const base = routeCrumb(pathname);
  const report = reportCrumb(pathname);
  return [
    ...(base ? [{ label: base.label, to: base.path }] : []),
    ...(report ? [{ label: report }] : []),
    ...pageCrumbs,
  ];
};
